import React from "react";
import { useUserContext } from "context/UserContext";
import ProductsBK from "layouts/BK/products";
import { isBkLikeRole } from "utils/roleUtils";

function Products() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role) || role === "CM") {
    return <ProductsBK />;
  }
  return null;
}

export default Products;
